import {
  Avatar,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  makeStyles,
  Typography,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { THEME_MODE } from "src/config/constants";

const useStyle = makeStyles((theme) => ({
  title: {
    padding: "10px 20px 10px 20px",
    background: theme.palette.type === THEME_MODE.DARK ? "#00244D" : "#F2F4F7",
  },
  confirmBut: {
    borderRadius: "6px",
    marginBottom: "10px",
    width: "100%",
  },
  contrast: {
    color: theme.palette.text.hint,
  },
}));

export default function BaseDialog(props) {
  const { assetName, assetIcon, children, butProps, maxWidth, open, onClose, hiddenButton, loading } = props;
  const cls = useStyle();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{ style: { padding: 0 } }}
      fullWidth
      maxWidth={maxWidth ? maxWidth : "xs"}
    >
      <DialogTitle className={cls.title}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Box display="flex" justifyContent="flex-start" alignItems="center">
            <Typography variant="h2" className={cls.contrast}>
              {assetName}
            </Typography>
            <Avatar src={assetIcon} style={{ width: "25px", height: "25px", marginLeft: "0.5rem" }} />
          </Box>
          <IconButton size="small" onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        {children}
        {!hiddenButton && (
          <Box display="flex" justifyContent="flex-end" width="100%">
            <Button variant="contained" color="primary" className={cls.confirmBut} {...butProps}>
              {loading ? <CircularProgress size={24} /> : "Confirm"}
            </Button>
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
}
